import { useCallback } from "react";
import { useSingleVesselContext } from "../state/singleVesselContext";
import * as types from "../state/actionTypes";

export function useSingleVesselStore() {
  const { state, dispatch } = useSingleVesselContext();

  const setCalculatorData = useCallback(
    (payload) => dispatch({ type: types.SET_CALCULATOR_DATA, payload }),
    [dispatch]
  );

  const setPortOperations = useCallback(
    (payload) => dispatch({ type: types.SET_PORT_OPERATIONS, payload }),
    [dispatch]
  );

  const setFleetList = useCallback(
    (payload) => dispatch({ type: types.SET_FLEET_LIST, payload }),
    [dispatch]
  );

  const setSelectedQuery = useCallback(
    (payload) => dispatch({ type: types.SET_SELECTED_QUERY, payload }),
    [dispatch]
  );

  const setSelectedVessel = useCallback(
    (payload) => dispatch({ type: types.SET_SELECTED_VESSEL, payload }),
    [dispatch]
  );

  const setSyncBunker = useCallback(
    (payload) => dispatch({ type: types.SET_SYNC_BUNKER, payload }),
    [dispatch]
  );

  const setIsOverride = useCallback(
    (payload) => dispatch({ type: types.SET_IS_OVERRIDE, payload }),
    [dispatch]
  );

  const setEstimationEstId = useCallback(
    (payload) => dispatch({ type: types.SET_ESTIMATION_EST_ID, payload }),
    [dispatch]
  );

  const setSplitHireArray = useCallback(
    (payload) => dispatch({ type: types.SET_SPLIT_HIRE_ARRAY, payload }),
    [dispatch]
  );

  const setPortDistanceResponse = useCallback(
    (payload) => dispatch({ type: types.SET_PORT_DISTANCE_RESPONSE, payload }),
    [dispatch]
  );

  const resetCalculatorStore = useCallback(
    () => dispatch({ type: types.RESET_CALCULATOR_STORE }),
    [dispatch]
  );

  return {
    ...state,
    setCalculatorData,
    setPortOperations,
    setFleetList,
    setSelectedQuery,
    setSelectedVessel,
    setSyncBunker,
    setIsOverride,
    setEstimationEstId,
    setSplitHireArray,
    setPortDistanceResponse,
    resetCalculatorStore,
    dispatch,
  };
}
